import * as React from 'react';

import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';

import './sov-filters-section-header.scss';

applyTranslations(require('../sov-filters.i18n.json'));

type Props = {
  msgKey: string,
  tooltipKey?: string,
  isRequired?: boolean
};

const FILTERS_MSG_KEY = 'sov_filters';

const SOVFiltersSectionHeader = (
  {
    msgKey,
    tooltipKey,
    isRequired
  }: Props
): JSX.Element => (
  <div className="sov-filters-section-header">
    <div className="sov-filters-section-header__text">
      {__t(`${FILTERS_MSG_KEY}.labels.${msgKey}`)}
    </div>
    {
      isRequired && (
        <div className="sov-filters-section-header__required form-required-mark">
          *
        </div>
      )
    }
    {
      tooltipKey && (
        <div className="sov-filters-section-header__tooltip">
          <Tooltip
            message={__t(`${FILTERS_MSG_KEY}.tooltips.${tooltipKey}`)}
            showQuestionMark
          />
        </div>
      )
    }
  </div>
);

export default SOVFiltersSectionHeader;
